<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="main-wrapper">
      <layout-header @changedLanguage="changedLanguage"></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> {{ $t('menu.supplier') }} </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">{{ $t('menu.supplier') }}</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <DisplayColumnsComponent :table="table" :columns="columns" v-if="table"></DisplayColumnsComponent>
                  </li>
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" @click.prevent="showSupplier(null)">{{ $t('new_entry') }}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <DataTableDSMS
            ref="dataTableDSMS"
            title="Supplier"
            fileName="Dienstleister"
            modelName="supplier"
            deleteURL="todos/v1/delete_supplier/"
            :extraActions="extraActions"
            :editorPatchURL="editorPatchURL"
            :columns="columns"
            :objects="supplierList"
            :exportColumns="[0, 1]"
            :editorCallback="true"
            @tableCreated="setTable"
            @editorCreated="setEditor"
            @showObject="showSupplier"
            @callDrawback="drawCallbackFunctions"
            @editorUpdated="patchSupplierList"
            v-if="promiseFinished"
          ></DataTableDSMS>

          <FingerPrintSpinner v-show="!promiseFinished" color="#9b3136" :size="300" :container-padding="100" />
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->

    <!--modal section starts here-->
      <!-- Modal -->
      <DKLVendor :supplier="current_supplier" @supplierUpdated="patchSupplierList">
        <template v-slot:fileUpload><FileUploadComponent :commentObject="current_supplier" modelName="supplier" :commentObjectList="supplierList" modelVerboseName="Dienstleister"></FileUploadComponent></template>
        <template v-slot:comments><CommentComponent :commentObject="current_supplier" modelName="supplier" @commentUpdated="updateSupplierForComment" modelVerboseName="Dienstleister"></CommentComponent></template>
      </DKLVendor><!-- modal -->

      <system :currentSystem="current_system" :departments="departments" @systemUpdated="updateSystem">
        <template v-slot:fileUpload><FileUploadComponent :commentObject="current_system" modelName="system" @attachmentUpdated="setSystem" modelVerboseName="System"></FileUploadComponent></template>
        <template v-slot:comments><comments :commentObject="current_system" modelName="system" @commentUpdated="setSystem" modelVerboseName="System"></comments></template>
      </system>
    </div>
  </div>
</template>
<script>
  import service from '@/utils/request.js';
  import {mapGetters, mapState} from 'vuex';
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';
  import {deepCopy, boolDisplay, updateDepartments, updateDataTypes} from '@/utils/index.js';
  import {newSupplier, newSystem, objectModalName} from "@/utils/enums";
  import DKLVendor from '@/components/component/VendorComponent'
  import CommentComponent from '@/components/component/CommentComponent'
  import FileUploadComponent from "@/components/component/FileUploadComponent";
  import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
  import comments from "@/components/component/CommentComponent.vue";
  import system from "@/components/component/SystemComponent.vue";
  import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
  import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";

  export default {
    components: {
      FingerPrintSpinner,
      DisplayColumnsComponent,
      system, comments,
      DataTableDSMS,
      DKLVendor,
      CommentComponent,
      FileUploadComponent
    },
    data() {
      return {
        supplierList: [],
        current_supplier: newSupplier,
        current_system: {},
        editorPatchURL: '/todos/v1/patch_supplier/',
        table: null,
        editor: null,
        promiseFinished: false,
      }
    },
    created() {
      this.getSuppliers()
    },
    validations() {
      return {
        current_supplier: {
          name: {required, $lazy: true},
          contract: {required, $lazy: true},
          responsible_department: {required, $lazy: true},
        },
      }
    },
    setup() {
      return {
        v$: useVuelidate()
      }
    },
    computed: {
      ...mapState({
        accountid: state => state.account.accountid,
        user: state => state.user,
        account: state => state.account,
        departments: state => state.account.departments,
        dataTypes: state => state.account.dataTypes,
        systems: state => state.account.systems
      }),
      ...mapGetters(['selectDepartmentOptions', 'selectDataTypeOptions', 'selectSystemOptions']),
      columns() {
        return [
        {
          label: 'Nr.#',
          name: 'sequence',
          enableEditor: false,
          definition: {data: "sequence", width: '50px', className: 'dkl-vt-sequence reorder'},
        },
        {
          label: this.$t('name'),
          name: 'name',
          type: 'text',
          enableEditor: true,
          definition: { data: "name" },
        },
        {
          label: 'Status',
          name: 'released',
          type: 'radio',
          options: [
            { label: "Angenommen", value: true },
            { label: "Vorgeschlagen",  value: false }
          ],
          enableEditor: true,
          definition: {data: "released", render: (data) => data ? 'Angenommen' : 'Vorgeschlagen'},
        },
        {
          label: this.$t('description'),
          name: 'description',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "description" },
        },
        {
          label: this.$t('purpose_data_processing'),
          name: 'purpose',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "purpose" },
        },
        {
          label: this.$t('systems'),
          name: 'systems',
          type: 'select2',
          opts: {
            multiple: true,
            closeOnSelect: false,
          },
          options: this.selectSystemOptions,
          enableEditor: true,
          definition: { data: "systems"},
        },
        {
          label: this.$t('processor'),
          name: 'data_processor',
          type: 'radio',
          enableEditor: true,
          options: [
            {label: 'Auftragsverarbeiter', value: true},
            {label: 'Kein Auftragsverarbeiter', value: false}
          ],
          definition: { data: "data_processor", render: data => boolDisplay[data] },
        },
        {
          label: this.$t('place'),
          name: 'place',
          type: 'text',
          enableEditor: true,
          definition: { data: "place" },
        },
        {
          label: this.$t('responsible_units'),
          name: 'responsible_department',
          type: 'select2',
          options: this.selectDepartmentOptions,
          enableEditor: true,
          definition: { data: "responsible_department"},
        },
        {
          label: this.$t('data_type'),
          name: 'data_type',
          type: 'select2',
          opts: {
            multiple: true,
            closeOnSelect: false,
            tags: true,
          },
          options: this.selectDataTypeOptions,
          enableEditor: true,
          definition: { data: "data_type"},
        },
        {
          label: this.$t('legal_base'),
          name: 'legal_base',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "legal_base" },
        },
        {
          label: this.$t('contract_w_date'),
          name: 'contract',
          type: 'text',
          enableEditor: true,
          definition: { data: "contract" },
        },
        {
          label: this.$t('checked'),
          name: 'checked',
          type: 'radio',
          options: [
            { label: "geprüft", value: true },
            { label: "nicht geprüft",  value: false }
          ],
          enableEditor: true,
          definition: { data: "checked", render: data => boolDisplay[data] },
        },
        {
          label: this.$t('subcontractor'),
          name: 'subcontractor',
          type: 'text',
          enableEditor: true,
          definition: { data: "subcontractor" },
        },
        {
          label: this.$t('subcontractor_checked'),
          name: 'subcontractor_checked',
          type: 'radio',
          options: [
            { label: "Unterauftragnehmer genehmigt", value: true },
            { label: "Unterauftragnehmer nicht genehmigt",  value: false }
          ],
          enableEditor: true,
          definition: { data: "subcontractor_checked", render: data => boolDisplay[data] },
        },
        {
          label: this.$t('document'),
          name: 'document',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "document" },
        },
        {
          label: this.$t('stand'),
          name: 'stand',
          type: 'text',
          enableEditor: true,
          definition: { data: "stand" },
        },
        {
          label: this.$t('modified'),
          name: 'modified',
          enableEditor: false,
          definition: { data: "modified", render: (data) => typeof data === 'string' ? data.substring(0, 10) : '' },
        },
      ]},
    },
    mounted() {
    },
    updated ()
    {

      // Date Time Picker

      if ($('.datetimepicker').length > 0) {
        $('.datetimepicker').datetimepicker({
          format: 'DD/MM/YYYY',
          icons: {
            up: "fa fa-angle-up",
            down: "fa fa-angle-down",
            next: 'fa fa-angle-right',
            previous: 'fa fa-angle-left'
          }
        });
      }
    },
    methods: {
      async changedLanguage() {
        this.$nextTick(async () => {
          if (this.table) this.table.destroy();
          await this.$refs.dataTableDSMS.initTable();
        });
      },
      setTable(table) {
        this.table = table
        this.highlightUnreleasedRows()
      },
      setEditor(editor) {
        this.editor = editor
        this.editor.field('responsible_department').update(this.selectDepartmentOptions)
        this.editor.field('data_type').update(this.selectDataTypeOptions)
        this.editor.field('systems').update(this.selectSystemOptions)
      },
      setSystem(systemObject) {
        this.current_system = systemObject
        this.updateSystems(systemObject)
        updateDepartments([systemObject.department], this.editor, 'responsible_department')
      },
      patchSupplierList(supplierObject) {
        updateDepartments([supplierObject.responsible_department], this.editor, 'responsible_department')
        updateDataTypes(supplierObject.data_type, this.editor)
        if (supplierObject.systems.length > 0) {
          const systems = supplierObject.systems
          let existSupplierIndex = -1
          let systemIndex = -1
          systems.forEach(system => {
            existSupplierIndex = this.supplierList.findIndex(supplier => supplier.systems.includes(system))
            if (existSupplierIndex > -1) {
              systemIndex = this.supplierList[existSupplierIndex].systems.indexOf(system)
              // this.supplierList[existSupplierIndex].systems = this.supplierList[existSupplierIndex].systems.splice(systemIndex, -1)
              this.supplierList[existSupplierIndex].systems.splice(systemIndex, 1)
            }
          })
        }
        const supplierIndex = this.supplierList.findIndex(item => item.id === supplierObject.id)
        if (supplierIndex === -1) {
          this.supplierList = this.supplierList.map(item => {
            item.sequence = item.sequence + 1
            return item
          })
          this.supplierList.push(supplierObject)
        } else {
          this.supplierList[supplierIndex] = supplierObject
        }
        this.table.clear().rows.add(this.supplierList).draw(false)
      },
      updateSupplierForComment(supplierObject) {
        const objectIndex = this.supplierList.findIndex(item => item.id === supplierObject.id)
        this.supplierList[objectIndex] = supplierObject
      },
      extraActions(data) {
        return `<a class="dropdown-item add-system" href="#" data-supplier-id="${data.id}">System hinzufügen</a>`
      },
      highlightUnreleasedRows() {
        const table = this.table || ($('#dkl-table').length && $.fn.dataTable.isDataTable('#dkl-table') ? $('#dkl-table').DataTable() : null)
        if (!table) return
        table.rows().every(function() {
          const data = this.data()
          const node = this.node()
          if (node) {
            if (data && !data.released) {
              $(node).addClass('supplier-unreleased')
            } else {
              $(node).removeClass('supplier-unreleased')
            }
          }
        })
      },
      drawCallbackFunctions() {
        const that = this
        this.highlightUnreleasedRows()
        $('.add-system').off('click').on('click', function(e) {
          e.preventDefault();
          const supplierID = $(e.target).data('supplier-id')
          that.current_supplier = that.supplierList.filter(supplier => supplier.id === parseInt(supplierID))[0]
          that.current_system = deepCopy(newSystem)
          $('#' + objectModalName.system).modal('show');
        })
      },
      updateSystem(systemObject) {
        this.current_supplier.systems.push(systemObject.name)
      },
      showSupplier(id) {
        if (id == null) {
          this.current_supplier = deepCopy(newSupplier)
        } else {
          this.current_supplier = this.supplierList.filter(item => item.id === id)[0]
        }
        $('#' + objectModalName.supplier).modal('show')
      },
      toggle_column(event, column_index) {
        // Get the column API object
        let column = $('.datatable').DataTable().column(column_index);

        // Toggle the visibility
        column.visible(!column.visible());

        // adjust dropdown menu
        if (column.visible() && !$(event.target).hasClass('selected')) {
          $(event.target).addClass('selected')
        } else if (!column.visible() && $(event.target).hasClass('selected')) {
          $(event.target).removeClass('selected');
        }
      },
      async getSuppliers() {
        service.request({
          url: `todos/v1/suppliers/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.supplierList = response.data;
          this.promiseFinished = true
        }).catch(function(err) {
          console.log(err)
          this.promiseFinished = true
        })
      },
    }
  }
</script>
<style scoped>
  ::v-deep #dkl-table tbody tr.supplier-unreleased:not(.selected),
  ::v-deep #dkl-table tbody tr.supplier-unreleased:not(.selected) > td,
  ::v-deep #dkl-table tbody tr.supplier-unreleased:not(.selected) > th,
  ::v-deep #dkl-table tbody tr.supplier-unreleased:not(.selected) > .dtfc-fixed-left {
    background-color: #ffebee !important;
  }

  ::v-deep #dkl-table tbody tr.supplier-unreleased:not(.selected):hover,
  ::v-deep #dkl-table tbody tr.supplier-unreleased:not(.selected):hover > td,
  ::v-deep #dkl-table tbody tr.supplier-unreleased:not(.selected):hover > th,
  ::v-deep #dkl-table tbody tr.supplier-unreleased:not(.selected):hover > .dtfc-fixed-left {
    background-color: #fee2e2 !important;
  }
</style>
<style>
  #dkl-table tbody tr.supplier-unreleased:not(.selected),
  #dkl-table tbody tr.supplier-unreleased:not(.selected) > td,
  #dkl-table tbody tr.supplier-unreleased:not(.selected) > th,
  #dkl-table tbody tr.supplier-unreleased:not(.selected) > .dtfc-fixed-left {
    background-color: #ffebee !important;
  }

  #dkl-table tbody tr.supplier-unreleased:not(.selected):hover,
  #dkl-table tbody tr.supplier-unreleased:not(.selected):hover > td,
  #dkl-table tbody tr.supplier-unreleased:not(.selected):hover > th,
  #dkl-table tbody tr.supplier-unreleased:not(.selected):hover > .dtfc-fixed-left {
    background-color: #fee2e2 !important;
  }
</style>
